<script setup lang="ts">
import { Popup as VarPopup, type PopupProps } from '@varlet/ui';

const show = defineModel<boolean>('show', { default: false });

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<PopupProps>();
</script>

<template>
  <VarPopup
    v-bind="props"
    v-model:show="show"
  >
    <slot />
  </VarPopup>
</template>

<style lang="scss">
.var-popup {
  &__content {
    border-radius: 24px;
    border: 1px solid var(--theme-border-strong);
    background-color: var(--theme-surface);
    box-shadow:
      0 30px 80px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
  }
}
</style>
